import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Image, Typography } from '@iho-design-system/Loader';

/*
    - icons
*/
import ChatSvg from '../assets/images/help-desk/chat.svg';
import CloseSVG from '../assets/images/help-desk/close.svg';

const HelpBadge = ({ toggleHelpDeskProps }) => {

    /*
        - default data
    */
    const [helpBadgeStatus, setHelpDeskStatus] = React.useState(true);

    const close = () => {
        setHelpDeskStatus(!helpBadgeStatus)
    }

    return (

        <React.Fragment>

            {helpBadgeStatus &&
                <Box
                    className={`my-md mt-0 p-lg rounded-lg position-fixed`}
                    ms={{
                        width: '240px',
                        backgroundColor: 'var(--white)',
                        boxShadow: 'var(--shadow-dark)',
                        right: '24px',
                        bottom: '-100%',
                        zIndex: '99999',
                        animation: 'animationOne 1s ease-in-out',
                        animationFillMode: 'forwards',
                        animationDelay: '0.5s',
                        '@keyframes animationOne': {
                            'from': {
                                bottom: '-100%'
                            },
                            'to': {
                                bottom: '64px'
                            }
                        },
                        '@media(max-width:600px)': {
                            display: 'none'
                        }
                    }}>
                    <Box
                        className={`d-flex justify-content-between`}>
                        <Typography
                            className={`d-block text-bold`}
                            component='h5'>
                            به کمک نیاز دارید؟
                        </Typography>
                        <Image
                            className={`pointer`}
                            onClick={close}
                            src={CloseSVG}
                            alt='close'
                            ms={{
                                width: '12px',
                                height: '12px'
                            }} />
                    </Box>
                    <Typography
                        className={`my-sm mt-0`}>
                        پشتیبان آنلاین، رباتی هستم که به صورت ۲۴ ساعته به درخواست‌های شما برای رزروهایی که انجام داده‌اید پاسخ می‌دهم.
                    </Typography>
                    <Button
                        onClick={toggleHelpDeskProps}
                        variant='outlined'
                        color='primary'
                        size='sm'
                        ms={{
                            width: '100%'
                        }}>
                        درخواست پشتیبانی
                    </Button>
                </Box>
            }
            <Box
                onClick={toggleHelpDeskProps}
                className={`p-sm rounded-circle pointer position-fixed`}
                ms={{
                    width: '48px',
                    hight: '48px',
                    backgroundColor: 'var(--blue-medium)',
                    boxShadow: 'var(--shadow-blue)',
                    right: '24px',
                    bottom: '-100%',
                    zIndex: '99999',
                    animation: 'animationTwo 1s ease-in-out',
                    animationFillMode: 'forwards',
                    '@keyframes animationTwo': {
                        'from': {
                            bottom: '-100%'
                        },
                        'to': {
                            bottom: '16px'
                        }
                    }
                }}>
                <Image
                    src={ChatSvg}
                    alt='helpDeskIcon' />
            </Box>

        </React.Fragment>

    );

}

export default HelpBadge;